import * as React from 'react';
import * as styles from './Title.css';
import Typography from '@material-ui/core/Typography/Typography';
import { Debt } from '../../../models/debt';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import TextField from '@material-ui/core/TextField/TextField';

interface TitleProps {
  text: string;
  center?: boolean;
  debtOptions?: any[];
  selectedDebt?: Debt;
  changedDebt?: (id: number) => void;
}

const Title = ({ text, center, debtOptions, selectedDebt, changedDebt }: TitleProps) => (
  <Typography
    color="textPrimary"
    variant="display1"
    className={styles.title}
    style={{ textAlign: center ? 'center' : 'left', marginTop: '50px' }}>
    {debtOptions ? (
      <TextField
        select
        value={selectedDebt!.id || ''}
        variant="outlined"
        // @ts-ignore
        onChange={e => changedDebt(e.target.value)}>
        {debtOptions.map(debt => (
          <MenuItem key={debt.data.id} value={debt.data.id}>
            <Typography color="textPrimary" variant="headline">
              {debt.data.name}
            </Typography>
          </MenuItem>
        ))}
      </TextField>
    ) : (
      <span>{text}</span>
    )}
  </Typography>
);

export default Title;
